import { render, staticRenderFns } from "./ServiceUpTip.vue?vue&type=template&id=baf91058"
import script from "./ServiceUpTip.vue?vue&type=script&lang=js"
export * from "./ServiceUpTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports